export const environment = {
  production: false,
  apiUrl: 'https://api-dev.coyotetextil.mx/',
  // apiUrl: 'http://34.133.52.151:3000',
};
